import MoreOptions from "./tableContainer/MoreOptions";
import {
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  Pagination,
  TextField,
  IconButton,
  Skeleton,
} from "@mui/material";

import React, { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterTable from "./FilterTable";
import Actions from "./tableContainer/Actions";
import TableInput from "./tableContainer/TableInput";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { SwapVertOutlined } from "@mui/icons-material";

function CustomTable({
  empty = false,
  cols,
  data = [],
  moreOptions = false,
  actions = false,
  filters = {},
  dispatch,
  count,
  title = "",
  page = 1,
  isPagination = true,
  renderParams = {},
  name = "",
  setIndex,
  roleId,
  setRoleId,
  nameColumn = "",
  inSiteDetails = false,
  selectedCols = "",
  loading = false,
}) {
  const headStyle = {
    color: "rgba(0, 0, 0, 0.4)",
    fontWeight: "400",
    fontSize: "12px",
    padding: "0px 16px",
    borderRight: "solid 1px rgba(0, 0, 0, 0.1)",
  };

  const handleChangePage = (event, newPage) => {
    if (selectedCols === "Employees") {
      dispatch({ type: "set_EmployeesPage", payload: newPage });
    } else if (selectedCols === "SitesEmployee") {
      dispatch({ type: "set_page_site", payload: newPage });
    } else dispatch({ type: "set_page", payload: newPage });
  };
  const [sortConfig, setSortConfig] = useState({
    key: nameColumn === "SiteBySales" ? "totalAmount" : "ticketCount",
    direction: "asc",
  });

  const [editing, setEditing] = useState(false);

  const crender = (row, col, i) => {
    const Col = col.customRender;
    return <Col {...data[i]} renderParams={renderParams} row={row} index={i} />;
  };

  const handleMulti = (row, col, i) => {
    col.customRender = false;

    return (
      <>
        {row.roles.map((role, index) => {
          return (
            <>
              {role.roleId === roleId && (
                <div
                  style={{
                    marginBottom: "20px",
                  }}>
                  <TextField
                    key={index}
                    type={col.type}
                    defaultValue={role.hourlyRate}
                    onChange={(e) => {
                      row.roles[index].hourlyRate = e.target.value;
                      setIndex(index);
                    }}
                    inputProps={{
                      style: {
                        width: col.number ? 85 : 185,
                        height: 5,
                      },
                    }}
                  />
                </div>
              )}
              {role.roleId !== roleId && (
                <div style={{ marginBottom: "20px" }}>{role.hourlyRate}</div>
              )}
            </>
          );
        })}
      </>
    );
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === "number") {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }

      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [data, sortConfig]);

  if (!cols) return;
  return (
    <>
      {filters !== null && (
        <FilterTable name={name} data={data} filters={filters} />
      )}
      <div style={{ padding: "5px" }}></div>

      <TableContainer sx={{ width: "100%" }}>
        <PerfectScrollbar style={{ maxWidth: "1200px" }}>
          <div>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  {cols.map((col, i) => (
                    <TableCell
                      key={`${col.label}${i}`}
                      {...col.props}
                      sx={
                        col.headTextLeft
                          ? { textAlign: "left", width: "auto", ...headStyle }
                          : { textAlign: "center", width: "auto", ...headStyle }
                      }>
                      {col.sortable && (
                        <IconButton
                          onClick={() => {
                            const isAsc =
                              sortConfig.key === col.name &&
                              sortConfig.direction === "asc";
                            setSortConfig({
                              key: col.name,
                              direction: isAsc ? "desc" : "asc",
                            });
                          }}>
                          <SwapVertOutlined />
                        </IconButton>
                      )}
                      {col?.label}{" "}
                    </TableCell>
                  ))}
                  {actions && (
                    <TableCell
                      style={{
                        cursor: "pointer",
                        fontSize: "12px",
                        textAlign: "center",
                        width: "300px",
                        ...headStyle,
                      }}>
                      Actions
                    </TableCell>
                  )}
                  {moreOptions && (
                    <TableCell
                      key={"MoreDetails"}
                      sx={{
                        color: "rgba(0, 0, 0, 0.4)",
                        fontWeight: "400",
                        padding: "0px 16px",
                        fontSize: "12px",
                        textAlign: "left",
                      }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}>
                        <span>More Details</span>
                        <MoreHorizIcon fontSize="small" />
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>

              {loading ? (
                <TableBody>
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <TableRow key={idx}>
                      {cols.map((col, i) => (
                        <TableCell key={i}>
                          <Skeleton variant="text" width="80%" height={24} />
                        </TableCell>
                      ))}
                      {actions && (
                        <TableCell>
                          <Skeleton variant="text" width="60%" height={24} />
                        </TableCell>
                      )}
                      {moreOptions && (
                        <TableCell>
                          <Skeleton variant="text" width="40%" height={24} />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              ) : !empty ? (
                <TableBody>
                  {sortedData.map((row, idx) => (
                    <TableRow
                      key={`${row.id || row.roleId || row.siteId}${idx}`}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        width: "max-content",
                      }}>
                      {cols.map((col, i) => (
                        <TableCell
                          key={`${col.name}${i}`}
                          sx={
                            col.textLeft
                              ? { fontSize: "12px" }
                              : {
                                  textAlign: "center",
                                  fontSize: "12px",
                                }
                          }>
                          {col.multiRow &&
                            editing === row?.siteId &&
                            col.editable && <>{handleMulti(row, col, i)}</>}

                          {col.customRender &&
                          (!col.editable || editing !== row.id) ? (
                            <>{crender(row, col, i)}</>
                          ) : col.editable &&
                            editing &&
                            (editing === row.id || editing === row.roleId) ? (
                            <TableInput
                              col={col}
                              index={idx}
                              idx={i}
                              data={data}
                              validations={actions.check}
                              actions={actions}
                              title={title}
                              multiRow={col.multiRow}></TableInput>
                          ) : (
                            <>
                              {row[col.name] !== null ? (
                                <span>{row[col.name]}</span>
                              ) : (
                                <span style={{ color: "gray" }}>-</span>
                              )}
                            </>
                          )}
                        </TableCell>
                      ))}
                      {actions && (
                        <TableCell
                          sx={{
                            padding: "0px 16px",
                            width: "300px",
                          }}>
                          <Actions
                            editing={editing}
                            setEditing={setEditing}
                            id={row.id || row.roleId || row.siteId}
                            actions={actions}
                            data={data}
                            name={title}
                            row={row}
                            roleId={roleId}
                            setRoleId={setRoleId}
                            col={cols}
                            inSiteDetails={inSiteDetails}></Actions>
                        </TableCell>
                      )}
                      {moreOptions && (
                        <TableCell
                          sx={{
                            padding: "0px 16px",
                          }}>
                          <MoreOptions
                            id={row.id}
                            moreOptions={moreOptions}
                            data={row}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody />
              )}
            </Table>

            {!loading && empty && (
              <div
                style={{
                  fontSize: "14px",
                  textAlign: "center",
                  padding: "20px",
                }}>
                No data available
              </div>
            )}
          </div>
        </PerfectScrollbar>

        {isPagination && (
          <Pagination
            count={count}
            onChange={handleChangePage}
            defaultPage={page}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginRight: "10px",
              marginTop: "17px",
              ".css-yuzg60-MuiButtonBase-root-MuiPaginationItem-root": {
                borderRadius: "8px",
              },
            }}
          />
        )}
      </TableContainer>
    </>
  );
}

export default CustomTable;
